const initState = ''
const phoneNumberReducer = (state = initState, action) => {
    switch (action.type) {
        case 'PHONE_NUMBER':
            return action.payload; 
        default:
            return state;
    }
}

export default phoneNumberReducer;